import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css"; // On importe le style qu'on va créer juste après

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
